<template>
	<div class="flex-row-align-center" style="width: 156px">
		<div class="font-h4-regular bgcolor-p-1 pl-8 pr-8 nowarp yx-color-text-secondary radius-2 cursor-pointer search-box" v-if="isEdit">
			<span class="yx-color-primary" @click="application()">默认筛选条件</span>
			<i class="el-icon-edit ml-6 hover" @click="openFilter()"></i>
			<i class="el-icon-close ml-6 hover" @click="delFilter()"></i>
		</div>
		<div class="flex-row-align-center" v-else>
			<span class="font-h4-regular yx-color-primary cursor-pointer" @click="openFilter">设置默认筛选条件</span>
		</div>
		<explain
			classStyle="yx-color-text-placeholder"
			content="设置默认筛选条件后，默认每次进入该页面展示默认筛选条件查询的数据"
			placement="top"
			class="ml-4"
		></explain>
		<default-filter-drawer
			@refresh="getFilter('confirm')"
			:dynamicsList="dynamicsList"
			:listType="listType"
			:platformId="platformId"
			ref="defaultFilterDrawer"
		/>
	</div>
</template>
<script>
import Explain from '@/components/common/explain';
import defaultFilterDrawer from './drawer';
import { getPageField, delPageField } from '@/api/common';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: +dataMap.PLATFORM_DY.value,
		},
		listType: {
			type: String,
			default: '',
		},
		defaultForm: {
			type: Object,
			default: () => ({}),
		},
		dynamicsList: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		Explain,
		defaultFilterDrawer,
	},
	computed: {
		isEdit({ formData }) {
			return !(Object.keys(formData).length === 0);
		},
		isQuery() {
			return Object.keys(this.$route.query).length !== 0;
		},
	},
	watch: {
		platformId: {
			handler(val) {
				this.getFilter('refresh');
			},
		},
	},
	data() {
		return {
			formData: {},
		};
	},
	mounted() {
		this.getFilter();
	},
	methods: {
		openFilter() {
			this.$refs.defaultFilterDrawer.show(this.formData, this.isEdit);
		},
		async getFilter(type = 'default') {
			const { listType, platformId } = this;
			const { fieldList = {} } = await getPageField({ list_type: `${listType}${platformId}` });
			this.formData = Object.keys(fieldList).length === 0 ? this.defaultForm : { ...this.defaultForm, ...fieldList };
			if (this.isQuery && type === 'default') return;
			this.application(type);
		},
		application(type = '') {
			if (type == 'clear') this.formData = JSON.parse(JSON.stringify(this.defaultForm));
			let data = JSON.parse(JSON.stringify(this.formData));
			this.$emit('applicationSetting', data);
			this.$Bus.$emit('applicationSetting', data);
		},
		async delFilter() {
			const { listType, platformId } = this;
			this.$modal({
				title: '提示',
				contentTitle: '是否清空默认筛选条件',
				size: 'small',
			}).then(async res => {
				if (res.key == 'confirm') {
					await delPageField({ list_type: `${listType}${platformId}` });
					this.$message.success('操作成功！');
					this.getFilter('clear');
					res.done();
				} else {
					res.done();
				}
			});
		},
	},
};
</script>
<style lang="less" scoped>
.search-box {
	width: 82px;
	overflow: hidden;
	transition: width 0.3s;
}
.search-box:hover {
	width: 120px;
}
</style>